import React from "react";

function scrollTo(selector, transition = "smooth", timeout = 500) {
  setTimeout(() => {
    // IE fallback.
    try {
      if (document.querySelector(selector)) {
        document.querySelector(selector).scrollIntoView({behavior: transition});
      }
      else {
        scrollTo(selector, transition, timeout);
      }
    } catch (error) {
      console.warn("The browser doesn't support Smooth scroll");
    }
  }, timeout);
}

export default scrollTo;
